import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";
import { api } from "../../lib/api";
import { PageHead } from "../../components/Bits";

export default function BuilderHome() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/builder/inspections").then(({ data }) => setList(data)); }, []);
  return (
    <div className="mx-auto max-w-5xl">
      <PageHead over="Builder rectification portal" title="Defect lists shared with you" />
      {list?.length === 0 && <p className="text-slate-500" data-testid="builder-empty">No inspection reports have been shared with you yet.</p>}
      <div className="space-y-2">
        {list?.map((i) => {
          const pct = i.total ? Math.round((100 * i.fixed) / i.total) : 100;
          return (
            <Link key={i.inspection_id} to={`/builder/inspection/${i.inspection_id}`} className="tap flex flex-col gap-3 rounded-lg border border-slate-200 bg-white p-4 hover:border-slate-900 sm:flex-row sm:items-center" data-testid={`builder-row-${i.inspection_id}`}>
              <div className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-slate-900 text-teal-300"><Building2 className="h-5 w-5" /></div>
              <div className="flex-1">
                <div className="font-mono text-xs font-bold">{i.inspection_id}</div>
                <div className="font-semibold">{i.property.project} · {i.property.flat} · {i.property.bhk} BHK</div>
                <div className="text-xs text-slate-500">{i.property.location} · inspected {i.inspection_date} by {i.inspector_name}</div>
              </div>
              <div className="w-44">
                <div className="h-1.5 rounded bg-slate-100"><div className="h-full rounded bg-emerald-500" style={{ width: `${pct}%` }} /></div>
                <div className="mt-1 font-mono text-[10px] text-slate-500">{i.fixed}/{i.total} fixed{i.rect_meta?.reinspection_id ? ` · RE-INSPECTION ${i.rect_meta.reinspection_id}` : ""}</div>
              </div>
              <ArrowRight className="h-4 w-4 text-slate-400" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
